import React from 'react'
import './claimsservice.scss'
import { Row , Col } from 'react-bootstrap'
import { images } from "../../../utils/customFn";
const ClaimService = () => {
    return (
        <>
            <div className='claim-service-cards'>
                <div className='heading'>
                    <h3>Our claims service</h3>
                    <p>When you make a claim with us, you’ll experience one of the major advantages of choosing Sentry. That’s because our in-house claims team will handle all aspects of your claim.</p>
                </div>
                <Row>
                    <Col sm={12} md={6} lg={4} xl={4}>
                       <div className='common-cards-claims'>
                          <img src={images['two-blue-computer-screens-card.svg']} alt="media" />
                          <h1>Customer online claims information</h1>
                       </div>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={4}>
                       <div className='common-cards-claims'>
                          <img src={images['two-blue-shields-card.svg']} alt="media" />
                          <h1>Customer online claims information</h1>
                       </div>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={4}>
                       <div className='common-cards-claims'>
                          <img src={images['speech-bubbles-card.svg']} alt="media" />
                          <h1>Customer online claims information</h1>
                       </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ClaimService